import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import {
  FiUser,
  FiLock,
  FiEye,
  FiEyeOff,
  FiCheck,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { API_BASE_URL } from "../config";
import jyotiLogo from "../assets/images/jyoti-logowhite-nepali.png";
import payment from "../assets/images/payment-cards-left2.png";
import { GrFacebookOption } from "react-icons/gr";
import { FaInstagram, FaWhatsapp } from "react-icons/fa6";

const features = [
  "Warranty Registration & Tracking",
  "Customer Management",
  "Product & Showroom Tracking",
  "Sales Reports & Analytics",
];
const products = [
  {
    title: "Health Care",
    href: "https://www.syakar.com.np/product-category/phillips-products/health-care/",
  },
  {
    title: "Kitchen",
    href: "https://www.syakar.com.np/product-category/phillips-products/household/kitchen/",
  },
  {
    title: "Floor Care",
    href: "https://www.syakar.com.np/product-category/phillips-products/household/floor-care/",
  },
  {
    title: "Garment Care",
    href: "https://www.syakar.com.np/product-category/phillips-products/household/garment_care/",
  },
  {
    title: "Personal Care",
    href: "https://www.syakar.com.np/product-category/phillips-products/personal-care/",
  },
  {
    title: "Mother & Child Care",
    href: "https://www.syakar.com.np/product-category/phillips-products/mother-child-_care/",
  },
  {
    title: "Preethi Kitchen Appliances",
    href: "https://www.syakar.com.np/product-category/preethi-products/kitchen-preethi-products/",
  },
];

const services = [
  {
    title: "Privacy Policy",
    href: "https://www.syakar.com.np/privacy-policy/",
  },
  {
    title: "Refund Policy",
    href: "https://www.syakar.com.np/refund_returns/",
  },
  {
    title: "Shipping & Return",
    href: "https://www.syakar.com.np/shipping-return/",
  },
  {
    title: "Terms & Conditions",
    href: "https://www.syakar.com.np/terms-conditions/",
  },
];
const FooterColumn = ({ title, items }) => (
  <div>
    <h4 className="mb-3.5 text-[18px] font-semibold">{title}</h4>

    <ul className="space-y-4 text-sm text-gray-300">
      {items.map((item) => (
        <li key={item.href}>
          <a
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary "
          >
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const loginResponse = await axios.post(
        `${API_BASE_URL}/api/auth/login`,
        formData,
      );
      localStorage.setItem("token", loginResponse.data.token);
      localStorage.setItem("user", JSON.stringify(loginResponse.data.user));
      toast.success("Login successful!");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-white login-page flex flex-col">
      {/* ── Header ── */}
      <header className="bg-white border-b border-[#ccc] relative z-30">
        <div className="max-w-[1170px] mx-auto flex items-center md:justify-between px-4 py-[7.5px] gap-2 md:gap-0">
          <button
            className="md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
            onClick={() => setMobileNavOpen(true)}
            aria-label="Open navigation"
          >
            <FiMenu size={22} />
          </button>
          <a href="http://www.syakar.com.np/" className="flex-none">
            <img
              src="/logo.png"
              alt="Syakar Company"
              className="h-[54px] w-auto object-contain"
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:block">
            <ul className="flex items-center lg:gap-10 gap-6">
              <li>
                <a href="https://www.syakar.com.np/">Home</a>
              </li>
              <li>
                <a href="https://www.syakar.com.np/product-category/philips-products/">
                  Philips Products
                </a>
              </li>
              <li>
                <a href="https://www.syakar.com.np/product-category/preethi-products/">
                  Preethi Products
                </a>
              </li>
              <li>
                <a href="https://www.syakar.com.np/about-us/">About Us</a>
              </li>
              <li>
                <a href="https://www.syakar.com.np/showroom/">Showroom</a>
              </li>
              <li>
                <a href="https://www.syakar.com.np/contact-us/">Contact</a>
              </li>
            </ul>
          </nav>

          {/* Hamburger button — mobile only */}
        </div>
      </header>

      {/* ── Mobile nav overlay + right drawer (outside header, fixed) ── */}
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-black/50 transition-opacity duration-300 md:hidden
                    ${mobileNavOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={() => setMobileNavOpen(false)}
      />

      {/* Right-side drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-72 z-50 bg-white shadow-2xl
                    flex flex-col transition-transform duration-300 ease-in-out md:hidden
                    ${mobileNavOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Drawer header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <img
            src="/logo.png"
            alt="Syakar Company"
            className="h-10 w-auto object-contain"
          />
          <button
            onClick={() => setMobileNavOpen(false)}
            className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
            aria-label="Close navigation"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Nav links */}
        <nav className="flex-1 overflow-y-auto py-4 px-4">
          <ul className="space-y-1">
            {[
              { label: "Home", href: "https://www.syakar.com.np/" },
              {
                label: "Philips Products",
                href: "https://www.syakar.com.np/product-category/philips-products/",
              },
              {
                label: "Preethi Products",
                href: "https://www.syakar.com.np/product-category/preethi-products/",
              },
              {
                label: "About Us",
                href: "https://www.syakar.com.np/about-us/",
              },
              {
                label: "Showroom",
                href: "https://www.syakar.com.np/showroom/",
              },
              {
                label: "Contact",
                href: "https://www.syakar.com.np/contact-us/",
              },
            ].map(({ label, href }) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={() => setMobileNavOpen(false)}
                  className="flex items-center px-4 py-3 rounded-lg text-sm font-medium
                             text-gray-700 hover:bg-philips-light-blue hover:text-philips-blue
                             transition-colors duration-150"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Drawer footer */}
        <div className="px-5 py-4 border-t border-gray-100">
          <p className="text-xs text-gray-400 text-center">
            © {new Date().getFullYear()} Syakar Company Pvt. Ltd.
          </p>
        </div>
      </div>

      {/* ── Page body ── */}
      <div className="flex-1 flex items-center justify-center py-14 px-4 ">
        <div className="w-full max-w-4xl">
          {/* Card */}
          <div className="rounded-2xl overflow-hidden flex flex-col lg:flex-row shadow-[0_12px_48px_rgba(10,92,142,0.15)] border border-philips-blue/15">
            {/* Top accent bar visible on mobile */}
            <div className="lg:hidden h-1.5 bg-philips-blue w-full" />

            {/* ── Left info panel ── */}
            <div className="lg:w-[44%] bg-[#1e6dcd] flex flex-col p-10 relative overflow-hidden">
              {/* Soft decorative shapes */}
              <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/[0.05] pointer-events-none" />
              <div className="absolute -bottom-32 -left-16 w-96 h-96 rounded-full bg-philips-dark-blue/30 pointer-events-none" />

              {/* Logo */}
              <div className="relative z-10 mb-8 self-start">
                <img
                  src={jyotiLogo}
                  alt="Jyoti Group"
                  className="h-12 w-auto object-contain"
                />
              </div>

              {/* Headline */}
              <div className="relative z-10 flex-1 pb-8">
                {/* <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-3">
                  Admin Portal
                </p> */}
                <h2 className="text-3xl font-bold text-white leading-snug mb-3">
                  Warranty
                  <br />
                  Management
                  <br />
                  System
                </h2>
                <p className="text-white/55 text-sm leading-relaxed">
                  Authorized Philips &amp; Preethi distributor portal for
                  managing product warranties and customer registrations.
                </p>
              </div>

              {/* Feature checklist */}
              <div className="relative z-10 mt-10 space-y-3 hidden md:block">
                {features.map((label) => (
                  <div key={label} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <FiCheck
                        size={11}
                        className="text-white"
                        strokeWidth={3}
                      />
                    </div>
                    <span className="text-white/75 text-sm">{label}</span>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <p className="relative z-10 text-white/25 text-xs mt-10 hidden md:block">
                &copy; {new Date().getFullYear()} Syakar Company Pvt. Ltd.
              </p>
            </div>

            {/* ── Right login panel ── */}
            <div className="flex-1 bg-white flex items-center justify-center p-10 lg:p-12">
              <div className="w-full max-w-sm">
                {/* Lock badge */}
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-10 h-10 rounded-xl bg-philips-light-blue flex items-center justify-center flex-shrink-0">
                    <FiLock size={18} className="text-philips-blue" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-syakar-navy leading-tight">
                      Welcome back
                    </h3>
                    <p className="text-gray-400 text-xs mt-0.5">
                      Sign in to your admin account
                    </p>
                  </div>
                </div>

                {/* Divider */}
                <div className="h-px bg-gray-100 mb-8" />

                <form onSubmit={handleSubmit} className="space-y-5">
                  {/* Email */}
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                      Email Address
                    </label>
                    <div className="relative">
                      <FiUser
                        className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
                        size={15}
                      />
                      <input
                        type="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        className="input-field pl-10 text-sm"
                        placeholder="admin@syakar.com.np"
                        required
                      />
                    </div>
                  </div>

                  {/* Password */}
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                      Password
                    </label>
                    <div className="relative">
                      <FiLock
                        className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
                        size={15}
                      />
                      <input
                        type={showPassword ? "text" : "password"}
                        value={formData.password}
                        onChange={(e) =>
                          setFormData({ ...formData, password: e.target.value })
                        }
                        className="input-field pl-10 pr-10 text-sm"
                        placeholder="Enter your password"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                        tabIndex={-1}
                      >
                        {showPassword ? (
                          <FiEyeOff size={15} />
                        ) : (
                          <FiEye size={15} />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn-primary w-full py-3 text-sm mt-1 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <>
                        <svg
                          className="animate-spin h-4 w-4 flex-shrink-0"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                          />
                        </svg>
                        Signing in...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </form>

                {/* <p className="text-center text-gray-300 text-xs mt-8">
                  Syakar Company Pvt. Ltd. &mdash; Authorized Philips Distributor
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-[#313336] text-white">
        <div className="max-w-[1440px] mx-auto grid gap-8 pt-16 pb-12 px-4 md:grid-cols-3">
          <FooterColumn title="Products" items={products} />
          <FooterColumn title="Services" items={services} />
          <div>
            <h4 className="mb-4 text-lg font-semibold">Company</h4>
            <ul className="space-y-3.5 text-gray-300 text-sm">
              <li>Jyoti Bhawan, 1919 Kantipath, PO Box 133</li>
              <li>+977-9802378222</li>
              <li>sales@syakar.com.np</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 bg-[#595959]">
          <div className="max-w-[1440px] mx-auto flex flex-col md:items-center md:justify-between gap-4 py-6 px-4 md:flex-row">
            <img
              src={jyotiLogo}
              alt="Jyoti Group"
              className="h-[100px] w-auto object-contain object-left "
            />
            <div>
              <h4 className="mb-3.5 text-[18px] font-semibold">Follow Us</h4>
              <div className="flex gap-5">
                <a
                  href="https://www.facebook.com/SyakarCompany/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white w-8 h-8 flex items-center justify-center  text-[21px] rounded-full text-black"
                >
                  <GrFacebookOption />
                </a>{" "}
                <a
                  href="tel:+977-1-5325490"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white w-8 h-8 flex items-center justify-center  text-[21px] rounded-full text-black"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://www.instagram.com/syakarcompanynepal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white w-8 h-8 flex items-center justify-center  text-[21px] rounded-full text-black"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
            <div className="">
              <h4 className="mb-3.5 text-[18px] font-semibold">
                Secure Payment By
              </h4>
              <img
                src={payment}
                alt="payment"
                className="h-[20px] w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Login;
